<template>
  <div class="life-preview">
    <el-dialog
      :title="title"
      :visible.sync="show"
      width="70%"
      top="29vh"
      @close="close"
    >
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="(item, i) in list" :key="i">
           <img :src="item" />
        </swiper-slide>

        <div v-if="indicatorDots" class="swiper-pagination"
        slot="pagination"></div>
      </swiper>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: '预览'
      },
      indicatorDots: {
      	type: Boolean,
      	default: false
      },
      list: {
        type: Array,
        default: () => ['', '']
      }
    },
    data() {
      return {
        show: false,
        swiperOptions: {
          pagination: {
            el: '.swiper-pagination'
          },
          autoplay: false,
          loop: true,
        }
      }
    },
    watch: {
      value(newVal) {
        this.show = newVal
      }
    },
    methods: {
      close() {
        this.$emit('input', false)
      }
    }
  }
</script>

<style lang="less" scoped>
  .life-preview {
    /deep/ .el-dialog {
      min-width: 300px;
      max-width: 750px;
      border-radius: 10px;
    }
    /deep/ .el-dialog__header {
      // padding: 20px 20px 10px;
      padding: 15px;
      border-bottom: 1px solid #f2f2f2;
    }
    /deep/ .el-dialog__headerbtn {
      top: 18px;
    }
    /deep/ .el-dialog__wrapper {
      z-index: 10000 !important;
    }
    /deep/ .el-dialog__title {
      letter-spacing: 1px;
    }
    /deep/ .v-modal {
      max-width: 750px;
      right: 0;
      margin: auto;
    }
    /deep/ .el-dialog__body {
      padding: 0 5px;
    }
    /deep/ .swiper-slide {
      width: 100% !important;
      padding: 42px 0;
      img {
        width: auto;
        height: 150px;
      }
    }
    /deep/ .swiper-pagination-bullet-active {
      background: #FF4444;
    }
  }

  @media screen and (min-width: 750px) {
    .life-preview {
      /deep/ .el-dialog {
        width: 300px !important;
      }
      /deep/ .swiper-slide {
        width: 100% !important;
        padding: 38px 0;
        img {
          width: auto;
          height: 200px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/life-preview.vue